import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { CentroCustoDropDown } from "../../../../../../common/domain/models/centro_custo_dropdown";
import { DefaultDateRangePickerInput } from "../../../../../../common/components/default_date_range_picker_input";
import DefaultInput from "../../../../../../common/components/default_input";

/**
 * Header Rateio Geral Lista.
 * 
 */

type Props = {
  ddlCentroCusto: CentroCustoDropDown[];
  selectedIdsCentroCusto?: number[];
  dataDe?: Date | null;
  dataAte?: Date | null;
  nroNotaFiscal?: string | null;

  handleNroNotaFiscalChange: (novoValor: string | null) => void;
  handleDataPagoRangeChange: (dataDe: Date | null, dataAte: Date | null) => void;
  onClearFilters: () => void;
  handleIdsCentroCustoChange: (v: number[]) => void;

};

export const Header = ({
  ddlCentroCusto,
  selectedIdsCentroCusto,
  dataDe,
  dataAte,
  nroNotaFiscal,

  handleNroNotaFiscalChange,
  handleDataPagoRangeChange,
  onClearFilters,
  handleIdsCentroCustoChange,

}: Props) => {

  const handleClearFilters = useCallback(() => {
    onClearFilters();

  }, [onClearFilters]);


  return (
    <>
      <CascateList
        title="Filtros"
        defaultOpen>
        <div className="w-full flex flex-col gap-6 items-center justify-center">
          <div className="w-full grid gap-6 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 grid-flow-row-dense">

            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >

              <div className="w-full">
                <DefaultMultiAutocomplete
                  label='Centro de Custo'
                  value={ddlCentroCusto.filter(x => selectedIdsCentroCusto?.includes(x.id))}
                  options={ddlCentroCusto}
                  getOptionLabel={x => x.title}
                  getOptionKey={x => x.id}
                  onChange={x => handleIdsCentroCustoChange(x?.map(y => y.id) ?? [])} />
              </div>

              <div className="w-full">
                <DefaultInput
                  name='nroNotaFiscal'
                  label='Nota Fiscal'
                  readOnly={false}
                  value={nroNotaFiscal}
                  onChangeValue={handleNroNotaFiscalChange} />
              </div>

            </div>


            <div className="flex col-span-1 md:col-span-2 lg:col-span-2 gap-1 " >
              <div className="w-[60%]">
                <DefaultDateRangePickerInput
                  label='Intervalo data pago'
                  dataDe={dataDe ?? null}
                  dataAte={dataAte ?? null}
                  onChange={async (start, end) => {
                    handleDataPagoRangeChange(start, end)
                  }}
                />
              </div>
            </div>

          </div>


          <div className="col-span-full w-full flex items-end gap-1">
            <div className="w-[180px] ml-auto">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>

        </div>

      </CascateList>
    </>
  );
}